import * as React from "react";

import { cn } from "@/lib/utils";
import { Eye, EyeOff } from "lucide-react";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  password?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, password, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false);

    const isPassword = password && type === "password";
    return (
      <div className="w-full">
        <div className="flex flex-1 relative">
          <input
            type={type}
            className={cn(
              "flex w-full rounded-xl md:h-[48px] h-[44px] border border-n-neutral-lighter bg-white py-3 px-3 text-base transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-n-neutral-light focus-visible:outline-none focus-visible:border-neutral-400  disabled:cursor-not-allowed disabled:opacity-50",
              className
            )}
            ref={ref}
            {...props}
          />
          {isPassword && (
            <button
              type="button"
              onClick={() => setShowPassword((prev) => !prev)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground"
              tabIndex={-1}
            >
              {showPassword ? (
                <EyeOff className="w-4 h-4" />
              ) : (
                <Eye className="w-4 h-4" />
              )}
            </button>
          )}
        </div>
        {error && <p className="text-n-error text-sm mt-1">{error}</p>}
      </div>
    );
  }
);
Input.displayName = "Input";

export { Input };
